import { Flex, Text, type FlexProps, type SelectProps } from '@mantine/core';
import classes from './FormCompanySelect.module.scss';
import { CompanySelect } from '@entities/company';

interface FormCompanySelectProps extends SelectProps {
  title?: string;
  description?: string;
  containerProps?: FlexProps;
}

export const FormCompanySelect = ({
  title = 'Компания',
  description = 'Выберите компанию-нанимателя',
  containerProps,
  ...props
}: FormCompanySelectProps) => {
  return (
    <Flex gap='24' className={classes.formRow} {...containerProps}>
      <Flex direction='column' gap={6} className={classes.leftColumn}>
        <Text className={classes.title}>{title}</Text>
        <Text className={classes.description}>{description}</Text>
      </Flex>

      <CompanySelect
        {...props}
        className={classes.rightColumn}
        variant='filled'
      />
    </Flex>
  );
};
